






import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class CircleButton extends Vue {
  @Prop({ type: String, required: true })
    text!: string;

  @Prop({ type: String, required: true })
    href!: string;
}
